module.exports = __webpack_public_path__ + "static/home-hero-9b3bbb8510b3097626824ef0119dff05.jpg";